import AuthFooter from "components/Footers/AuthFooter";
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import React from 'react';

const PrivacyPolicy = () => {
    return (
        <>
            <IndexNavbar />
            <div
                className="container"
                style={{
                    fontFamily: "Raleway sans-serif !important",
                    textAlign: "justify",
                    fontSize: "medium"
                }}
            >
                <section
                    className="mb-0 pt-10"
                    id="about"
                    style={{
                        marginBottom: "20px !important",
                        fontFamily: "Raleway sans-serif",
                        marginTop: 50
                    }}
                >
                    <div className="container" id="term">
                        <div className="mb-5 text-center">
                            <h3 className="fs-xl-10 fs-lg-8 fs-7 fw-bold text-capitalize">
                                PRIVACY POLICY
                            </h3>
                        </div>
                        <div className="row">
                            <h3>1. INTRODUCTION</h3>
                            <p>
                                This privacy policy describes how Truck4Me collects, stores, uses and
                                protects personal information in accordance with all its legal
                                obligations, including compliance with the Data Protection Act, 2012
                                (Act 843) of Ghana. By “personal information” we refer to all personal
                                and sensitive information that can be associated with a specific
                                person and can be used to identify that person.
                                <br />
                                <br />
                                By “personal information” we refer to all personal and sensitive
                                information that can be associated with a specific person and can be
                                used to identify that person.Your personal information is collected
                                when you use our website{" "}
                                <a href="https://truck4me.africa/">www.truck4me.africa</a> (“Website”)
                                or mobile or web platforms (“Platforms”) (“Service(s)”) (including,
                                without limitation, when you call or email our customer support team).
                                <br />
                                <br />
                                By providing your personal information you expressly consent to us
                                processing your personal information in accordance with the terms of
                                our Privacy Policy.Our Privacy Policy and Terms &amp; Conditions may
                                be amended or updated occasionally to meet requirements and standards
                                so it is important for you to frequently visit these sections in order
                                to be up to date with those changes. Modifications will be effective
                                on the day they are posted and by continuing to use our you will be
                                deemed to have consented to the terms of the Amended Privacy Policy as
                                of the effective date.
                                <br />
                                <br />
                            </p>
                            <h4> 2. COLLECTION OF YOUR PERSONAL INFORMATION </h4>
                            As part of your registration on the Website or Platforms, you will be
                            asked to provide us with certain personal information, including your
                            name, address, email address, telephone number, geographical location,
                            shipping address, ratings and other similar information as well as some
                            additional information about your company such as fleet size, driving
                            routes, vehicles details, drivers identification or other identifying
                            information.
                            <br />
                            <br />
                            In order for us to verify your identity, we may need to request valid
                            proof of identification for you and your company (e.g. in the form of a
                            copy of Company registration, Passport/National ID card, Driver’s
                            license, Car Registration Card, Transit documents).
                            <br />
                            <br />
                            Additionally, we will also need to collect selected financial
                            information from you, such as your credit card and/or bank account
                            details, which you will need to input into the “My Account” section of
                            our Website or Platforms. This financial information will be used for
                            billing purposes and for the fulfilment of your orders. You should
                            refrain from posting any personal information anywhere else than
                            indicated. Posting your personal information anywhere else than in My
                            Account section of the website or platforms may lead to the suspension
                            of your use of the Website or Platforms. Transactional information will
                            be collected based on your activities using the service (such as
                            shipping, transporting goods and participating in auctions). This
                            transactional information is used solely in relation to the transactions
                            you undertake on our Website and Platforms and for no other reasons.
                            <br />
                            <br />
                            Please note that information may also be automatically received and
                            recorded from your computer, browser or other computerised devices such
                            as mobile phones or tablets used to access our services including your
                            Internet protocol (or IP) address (which is a unique number assigned to
                            your computer server or your Internet service provider (or ISP)), cookie
                            information, software and hardware attributes. This information will
                            only be applied for purpose of improving the administration of the
                            website and platforms.
                            <br />
                            <br />
                            We may also collect information through Analytical tools (for example
                            Google Analytics and such similar analytical tools) which collects
                            information related to the browser used, the pages you visit on the
                            website along with the times you accessed the Website, your contact with
                            our customer support team, rating, and feedbacks. We may also collect
                            additional information from or about you in other ways not specifically
                            described here.
                            <br />
                            <br />
                            Where we aggregate personal information for statistical purposes, such
                            aggregated personal information shall be anonymised and will therefore
                            not be combined with personally identifiable information.
                            <br />
                            <br />
                            <p />
                            <p></p>
                            <h4>
                                3. USE OF YOUR PERSONAL INFORMATION AND WHAT WE DO NOT DO WITH YOUR
                                PERSONAL INFORMATION
                            </h4>
                            We use your information to:
                            <br />
                            <ul>
                                <li>fulfill requests for products, services and information;</li>
                                <li>
                                    analyse the geographical compatibility between transporters and
                                    shippers and provide suggestions to both;
                                </li>
                                <li>
                                    enhance our service and shippers’ security by letting them know the
                                    driver’s or transporters information and monitor their geolocation
                                    once goods have been picked up;
                                </li>
                                <li>improve our services;</li>
                                <li>prevent illegal activities;</li>
                                <li>troubleshoot problems;</li>
                                <li>provide you with promotional emails;</li>
                                <li>
                                    process and verify information with banks or credit card
                                    authorisation;
                                </li>
                                <li>
                                    verify information you provide with third parties for fraud
                                    screening purposes;
                                </li>
                                <li>provide services and customer support;</li>
                                <li>conduct research;</li>
                                <li>generate anonymous analytics.</li>
                            </ul>
                            Though we make every effort to preserve your privacy, we may need to
                            disclose your personal information to law enforcement agencies,
                            government agencies or other third parties where we are compelled so to
                            do by court order or similar legal procedure; where we are required to
                            disclose your personal information to comply with law; where we are
                            cooperating with an ongoing law enforcement investigation or where we
                            have a good faith belief that our disclosure of your personal
                            information is necessary to prevent physical harm or financial loss, to
                            report suspected illegal activity or to investigate a possible violation
                            of our User Agreement.
                            <br />
                            <br />
                            In the event of a sale, acquisition or merger of Truck4Me Limited, any
                            of its affiliates and subsidiaries or any related business assets, your
                            personal information may be disclosed to any potential purchaser for the
                            purposes of the continued provision of the website and platforms or
                            otherwise in relation to any such sale, acquisition or merger. As part
                            of our obligations, we will notify you of the personal information
                            transferred and an updated or different privacy policy will be put in
                            place. We may share your personal information with our other group
                            companies so as to provide joint content and services to you, to help
                            detect illegal acts and/or the violations of our policies.
                            <br />
                            <br />
                            We may also share your personal information as part of a bid on the
                            website or mobile platforms. For example, at the end of a successful bid
                            on the website or platforms we will provide the shipper and the
                            successful transporter with each other’s contact information. This
                            contact information will be the personal information provided by you to
                            us on registration and, as a result, should always be kept up-to-date,
                            will only be used for the purpose of fulfilling the delivery services.
                            <br />
                            <br />
                            Additionally, information relating to items you are shipping or
                            transporting will be displayed on the website or mobile platforms. This
                            information can include details of your user ID, feedback ratings and
                            associated comments relating to your use of the website and platforms.
                            <br />
                            <br />
                            We do our best to limit access to personal information about you to our
                            trusted partners who we believe reasonably need to come into contact
                            with that information to provide products or services to you in order to
                            do their jobs. However, these trusted partners do not have the
                            independent right to use or share this information beyond the preview of
                            our agreement with them.
                            <br />
                            <br />
                            Otherwise, we will only disclose your personal information to a third
                            party with your express permission.
                            <br />
                            <br />
                            We do use comments made by you about the website and platforms for
                            marketing purposes and by making such comments you expressly consent to
                            our using such comments for marketing purposes.
                            <br />
                            <br />
                            By registering on our platform, you give us your express consent to
                            receive promotional emails about our services and emails announcing
                            changes to, and new features on our website and mobile platforms. If, at
                            any time, you decide that you do not wish to receive any such emails,
                            you can opt out of receiving such emails by clicking on the link at the
                            bottom of any of the emails or by going to the My Account section of the
                            Site.
                            <br />
                            <br />
                            What we do not do:
                            <br />
                            <ul>
                                <li>
                                    We do not store, sell, share, rent or lease your credit/debit cards
                                    details and personally identifiable information to any third
                                    parties;
                                </li>
                                <li>
                                    We do not sell or rent any of your personal information to third
                                    parties in the normal course of doing business and will only share
                                    your personal information with third parties in accordance with this
                                    privacy policy.
                                    <br />
                                    <br />
                                </li>
                                <li>
                                    We do not collect any information from any person under 18 years of
                                    age. Our Website, mobile platforms, products and services are all
                                    directed to people who are at least 18 years old.
                                </li>
                                <br />
                                <br />
                            </ul>
                            <h5>
                                4. HOW YOU USE YOUR PERSONAL INFORMATION AND OTHER USERS’ PERSONAL
                                INFORMATION
                            </h5>
                            Website or platforms users (“Member(s)” or “User(s)”) may need to share
                            personal information (including financial information) with each other
                            to complete transactions on the Website or platforms. You should
                            respect, at all times, the privacy of other Website or platforms
                            members.
                            <br />
                            <br />
                            We cannot guarantee the privacy of your personal information when you
                            share personal information with other Website or platforms members so
                            you should always seek information on the privacy and security policies
                            of any other Website or platforms members with whom you are transacting
                            prior to sharing any of your personal information with another Website
                            or platforms member.
                            <br />
                            <br />
                            This privacy policy does not cover your release of your personal
                            information to another member. You agree to use any personal information
                            received from another member in relation to a transaction on the Website
                            or platforms solely in relation to such transaction and shall not use
                            the information received from another member for any other purposes
                            (except with the express consent of the other member(s)). You
                            acknowledge and agree that you shall use personal information received
                            from another member in accordance with all applicable laws.
                            <br />
                            <br />
                            <h5>5. REVIEWING AND UPDATING YOUR PERSONAL INFORMATION</h5>
                            You can access and review your personal information in the My Account
                            section of the Website or platforms. If your personal information
                            changes in any way or is incorrectly presented on the Website or
                            platforms you should immediately update or correct your personal
                            information (as applicable) by accessing the My Account section on the
                            Website or platforms or, alternatively, by contacting our customer
                            support team or sending an email to{" "}
                            <a href="mailto:info@truck4me.africa">info@truck4me.africa</a>
                            <br />
                            <br />
                            The “Customer Support” link contains our customer support email and
                            phone details. Please note that we shall retain your personal
                            information during and following the end of your use of the Website or
                            platforms as required to comply with law, for technical troubleshooting
                            requirements, to prevent fraud, to assist in any legal investigations
                            and to take any other actions otherwise permitted by law.
                            <br />
                            <br />
                            <h4>6. DATA GENERATED DURING THE USE OF OUR SERVICES</h4>
                            Geolocation data: We collect approximate location data to enable and
                            enhance use of our apps, including to improve loading and offloading of
                            shipments, enable safety features, prevent and detect fraud. Provided
                            that this has been enabled by users, we collect such data from users’
                            electronic devices. Truck4Me collects this data when the Truck4Me app is
                            running in the foreground (app open and on-screen) or background (app
                            open but not on-screen and app closed but not on-screen) of their mobile
                            device. Truck4Me collects such data from the time a shipment has been
                            booked with a driver until it has been offloaded (and may indicate such
                            collection via an icon or notification on your mobile device depending
                            on your device’s operating system).&nbsp;Drivers may use the Truck4Me
                            apps without enabling Truck4Me to collect precise location data from
                            their mobile devices. However, this may affect features.
                            <br />
                            <br />
                            Document uploads:We enable drivers to upload documents in order to
                            provide proof that the transported goods have been offloaded at the
                            destination address. Only registered and relevant users have access to
                            these documents, and they are not shared with any third parties, other
                            than as necessary to fulfil our services.
                            <br />
                            <br />
                            <h4>7.THIRD PARTY Information</h4>
                            Some of the advertisements you see on the Website or Platforms are
                            selected and delivered by third parties, such as ad networks,
                            advertising agencies, advertisers, and audience segment providers. These
                            third parties may collect information about you and your online
                            activities, either on the Website or platforms or on other websites,
                            through cookies, web beacons, and other technologies in an effort to
                            understand your interests and deliver to your advertisements that are
                            tailored to your interests. Please remember that we do not have access
                            to, or control over, the information these third parties may collect.
                            The information practices of these third parties are not covered by this
                            privacy policy.
                            <h4>8. USE OF COOKIES</h4>
                            Like many websites, the Website or Platforms uses ‘cookie’ technology
                            (small computer files placed on your computer’s hard drive). When you go
                            to particular website pages on the Site, the cookie identifies your
                            browser with a unique, random number.
                            <br />
                            <br />
                            The cookies we use do not reveal any personal information about you.
                            Cookies help us improve your experience of the service. It also helps us
                            understand which parts of the Site are the most popular. You are always
                            free to decline our cookies if your browser permits, although doing so
                            may interfere with your use of the service.
                            <br />
                            <br />
                            <h4>9. NO SPAM EMAILS</h4>
                            We automatically scan and may manually filter messages to check for
                            spam, viruses, phishing attacks and other malicious activity or illegal
                            or prohibited content.
                            <br />
                            <br />
                            <h4>10. PROTECTING YOUR PERSONAL INFORMATION</h4>
                            We hold your personal information on servers located in the France. By
                            providing us with personal information, you consent to the transfer of
                            your personal information to, and its storage on, our servers located in
                            France. We take every precaution to safeguard all your personal
                            information from unauthorized access, use or disclosure.
                            <br />
                            <br />
                            All personal information is encrypted. However, the Internet is not a
                            secure medium and we cannot guarantee the privacy of your personal
                            information. You must enter your username and password each time you
                            want to access your account or make transactions on the Website or
                            Mobile platforms.
                            <br />
                            <br />
                            Choose your password carefully using unique numbers, letters and special
                            characters. Never share your username and password with anyone.
                            <br />
                            <br />
                            If you are concerned that your username or password has been
                            compromised, please contact our customer support team immediately and
                            ensure you change your password by logging onto the My Account section
                            of the Website or Mobile Platforms.
                            <br />
                            <br />
                            <h4>11. DATA PROTECTION OFFICER</h4>
                            As part of the Data Protection Act Data Protection Act, 2012 (Act 843)
                            it is mandatory for Truck4Me to formally appoint Data Protection Officer
                            (“DPO”). The DPO will be included in any matters involving data
                            protection at the earliest possible stage, including privacy impact
                            assessments, data processing activities that may affect the use of your
                            personal information.
                            <br />
                            <br />
                            The DPO’s responsibility will include:
                            <ul>
                                <li>
                                    informing and advising Truck4Me, its employees, and third-party data
                                    processors of their obligations under the Data Protection Act;
                                </li>
                                <li>
                                    monitor compliance with The Data Protection Commission (DPC) and
                                    Truck4Me policies in relation to the protection of personal data,
                                    including raising awareness of these policies amongst Truck4Me
                                    employees, ensuring relevant and continuous staff training, and
                                    auditing and reviewing Truck4Me systems and procedures;
                                </li>
                                <li>
                                    to act as the contact point with the supervisory authority on issues
                                    relating to Truck4Me’s processing activities; to ensure a strict
                                    code of confidentiality concerning their role as DPO;
                                </li>
                                <li>
                                    to provide advice to Truck4Me, where requested, regarding Data
                                    Privacy Impact Assessments and to monitor our performance.
                                </li>
                                <li>
                                    the DPO should be notified of data breaches, processor agreements or
                                    as per data breach management policy at{" "}
                                    <a href="mailto:info@truck4me.africa">info@truck4me.africa</a>
                                </li>
                            </ul>
                            <h5>12. DATA PROTECTION BREACH</h5>
                            A personal data breach is described as a breach of security leading to
                            the accidental or unlawful destruction, loss, alteration, unauthorized
                            disclosure of, or access to, personal data transmitted, stored or
                            otherwise processed.
                            <br />
                            <br />
                            Truck4Me should be notified immediately of any data breaches as per the
                            Data Protection Act, 2012 (Act 843) breach management policy.
                            <br />
                            <br />
                            A record of any data breach that occurs, including a description of the
                            breach, its effects and the remedial action taken, will be kept in the
                            Truck4Me Data Breach Log.
                            <br />
                            <br />
                            Where the personal data breach results in a high risk to the rights and
                            freedoms of a member, Truck4Me is obliged to inform the member
                            immediately.
                            <br />
                            <br />
                            In the event of a data breach, Truck4Me’s `Data Breach Management
                            Policy’ outlines the procedure to be followed in responding to and
                            managing the breach.
                            <br />
                            <br />
                            {/* Additionally, the Data Protection Officer should be immediately notified
                            at <a href="mailto:info@truck4me.africa">info@truck4me.africa</a> */}
                            <h4>13. TRAINING AND MONITORING OF EMPLOYEES</h4>
                            All Truck4Me’s employees will receive data protection training specific
                            to their role. This training will be periodically reviewed and refreshed
                            to ensure continuing professional development in the area of data
                            protection law and the general data protection regulation.
                            <br />
                            <br />
                            Methods of collecting, holding and processing personal data will be
                            regularly evaluated and reviewed. All employees, trusted partners and
                            third parties working on behalf of Truck4Me will be made fully aware of
                            both their individual responsibilities and Truck4Me’s responsibilities
                            under the Regulation and under this Policy.
                            <br />
                            <br />
                            <h5>14. QUESTION ABOUT OUR PRIVACY POLICY</h5>
                            If you have questions or concerns about our collection and use of your
                            personal information, please contact our customer support or send us an
                            email at <a href="mailto:info@truck4me.africa">info@truck4me.africa</a>
                            <p />
                        </div>
                    </div>
                </section>
            </div>
            <AuthFooter />
        </>
    );
};


export default PrivacyPolicy;